// 模式：素材上传 ｜ 多语言裂变
export enum ReplaceMode {
  // 素材上传
  Upload = 'upload',
  // 多语言裂变
  Languages = 'languages',
}

// 多语言模式： 多语言裂变 ｜ 详情
export enum LanguagesMode {
  // 多语言裂变
  Languages = 'languages',
  // 详情
  Detail = 'detail',
}

export enum LanguagesTab {
  // 布局模版
  Layout = 'layout',
  // 视频元件下的字幕配音
  Segment = 'segment',
}
